var React = require('react');

function GraduationCap60px (props) {
    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M55 38.945c-1.654 0-3-1.346-3-2.999 0-1.3.839-2.399 2-2.813V17.662l-10 5.551v18.844c0 .031-.015.058-.018.089a.984.984 0 0 1-.451.849c-.257.161-6.395 3.943-15.531 3.943-9.136 0-15.274-3.782-15.531-3.943a.984.984 0 0 1-.451-.849c-.003-.031-.018-.058-.018-.089V23.213L.515 16.837a.998.998 0 0 1 0-1.746l27-14.988c.3-.167.67-.167.97 0l27 14.988c.318.176.515.51.515.872 0 .018-.013.032-.013.049.001.024.013.043.013.067v17.054c1.161.414 2 1.513 2 2.813a3.003 3.003 0 0 1-3 2.999zm-13 2.621V24.323l-13.515 7.502a.993.993 0 0 1-.485.125.993.993 0 0 1-.485-.125L14 24.323v17.243c1.535.83 6.821 3.373 14 3.373s12.465-2.543 14-3.373zM28 2.12L3.06 15.963 28 29.808l24.94-13.845L28 2.12zm27.287 32.885c-.093.029-.185.058-.287.058-.102 0-.194-.029-.286-.058a.989.989 0 0 0-.714.941 1 1 0 0 0 2 0 .99.99 0 0 0-.713-.941z","key":1})]);
}

GraduationCap60px.displayName = "GraduationCap60px";

GraduationCap60px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 58 46.94"};

module.exports = GraduationCap60px;

GraduationCap60px.default = GraduationCap60px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/60px/graduation-cap-60px.svg
// module id = 1192
// module chunks = 0